import { UseQueryOptions } from 'react-query'

import { useMutationApi, useQueryApi } from 'utils/api'
import { baseAPIPathGuruKS } from 'configs/api'

export const basePath = `${baseAPIPathGuruKS}/v1/usulan`

export type SelectionType =
  | 'seleksi-kepala-sekolah'
  | 'seleksi-pengawas-sekolah'

export const useAPICreateDraft = (
  selectionType: SelectionType,
  selectionId: string
) =>
  useMutationApi<any, Error, any>(
    `${basePath}/${selectionType}/${selectionId}/draf`,
    {
      axiosConfig: {
        method: 'POST',
      },
    }
  )

export const useAPIPostUsulan = (
  selectionType: SelectionType,
  selectionId: string
) =>
  useMutationApi<any, Error, FormData>(
    `${basePath}/${selectionType}/${selectionId}`,
    {
      axiosConfig: {
        method: 'POST',
      },
    }
  )

export const useAPIPostUsulanStatus = (
  selectionType: SelectionType,
  selectionId: string
) =>
  useMutationApi<any, Error, { status: 'UNDEFINE' | 'DEFINITIF' | 'PJ' }>(
    `${basePath}/${selectionType}/${selectionId}/status`,
    {
      axiosConfig: {
        method: 'POST',
      },
    }
  )

export const useAPISubmitUsulan = (
  selectionType: SelectionType,
  selectionId: string
) =>
  useMutationApi<any, Error, any>(
    `${basePath}/${selectionType}/${selectionId}/submit`,
    {
      axiosConfig: {
        method: 'PATCH',
      },
    }
  )

export const useAPIFinalizeUsulan = (
  selectionType: SelectionType,
  selectionId: string
) =>
  useMutationApi<any, Error, any>(
    `${basePath}/${selectionType}/${selectionId}/final`,
    {
      axiosConfig: {
        method: 'PATCH',
      },
    }
  )

export interface ResponseSuccessGetStatusUsulan {
  data: {
    id: string
    selectionType: string
    selectionId: string
    status: 'draf' | 'pengusulan' | 'diterima' | 'ditolak' | 'final'
    noSurat: string
    tanggalSurat: string
    perihal: string
    nipJabatan: string
    jabatanPejabat: string
    instansi: string
    pertekFileUrl: string
    beritaAcaraFileUrl: string
    suratPengantarFileUrl: string
  }
}

export const useAPIGetStatusUsulan = (
  selectionType: SelectionType,
  selectionId: string,
  options: {
    queryConfig?: UseQueryOptions<ResponseSuccessGetStatusUsulan>
  } = {}
) =>
  useQueryApi<ResponseSuccessGetStatusUsulan>(
    `${basePath}/${selectionType}/${selectionId}`,
    {
      queryConfig: {
        enabled: !!selectionType && !!selectionId,
        retryOnMount: true,
        ...options.queryConfig,
      },
    }
  )

interface ParamsGetUsulanCandidates {
  page?: number
  pageSize?: number
}

export type UsulanCandidatesGlobalStatus = 'valid' | 'invalid'

export interface DetailStatus {
  key: string
  value: any
  description: string
}

export interface UsulanCandidate {
  id: string
  ptkId: string
  nama: string
  institusi: {
    nama: string
  }
  jenjangJabatan: string
  status: 'valid' | 'warning' | 'invalid'
  detailStatus: DetailStatus[]
}

export interface ResponseSuccessGetUsulanCandidates {
  data: {
    detailStatus: DetailStatus[]
    moreKandidat: UsulanCandidate[]
    status: UsulanCandidatesGlobalStatus
  }
  meta: {
    page: number
    pageSize: number
    total: number
  }
}

export const useAPIGetUsulanCandidates = (
  selectionType: SelectionType,
  selectionId: string,
  params: ParamsGetUsulanCandidates = {
    page: 1,
    pageSize: 10,
  }
) =>
  useQueryApi<ResponseSuccessGetUsulanCandidates>(
    `${basePath}/${selectionType}/${selectionId}/kandidats`,
    {
      axiosConfig: {
        params,
      },
    }
  )

export const useAPIUploadPAK = (
  selectionType: SelectionType,
  selectionId: string,
  candidateId: string
) =>
  useMutationApi<any, Error, FormData>(
    `${basePath}/${selectionType}/${selectionId}/kandidats/${candidateId}/dokumens/penetapan-angka-kredit`,
    {
      axiosConfig: {
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    }
  )
